import { render, staticRenderFns } from "./VBlog.vue?vue&type=template&id=06e79b67&scoped=true"
import script from "./VBlog.vue?vue&type=script&lang=js"
export * from "./VBlog.vue?vue&type=script&lang=js"
import style0 from "./VBlog.vue?vue&type=style&index=0&id=06e79b67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e79b67",
  null
  
)

export default component.exports